import { apiClient} from '@repo/shared';

const initialiseNewUser = () => {
  return {
    id: null,
    username: '',
    email: '',
    role: '',
    changePassword: true,
    firstLogin: true,
  };
}

const getAll = async () => {
  console.log("API CLIENT!", apiClient);
  const users = await apiClient.get("/api/users");
  return users;
};

const get = async (id) => {
  const user = await apiClient.get(`/api/users/${id}`);
  return user?.[0];
};

const create = async (user) => {
  const users = await apiClient.post(`/api/users`, user);
  return users;
};

const update = async (id, user) => {
  const users = await apiClient.post(`/api/users/${id}`, user);
  return users;
};

const remove = async (id) => {
  //return http.delete(`/klassen/${id}`);
  const users = await apiClient.delete(`/api/users/${id}`);
  return users;
};

const resetPassword = async (id) => {
  const users = await apiClient.post(`/api/users/${id}/reset-password`);
  return users;
};

const UserService = {
  getAll,
  get,
  create,
  update,
  remove,
  initialiseNewUser,
  resetPassword,
};

export default UserService;